import React from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { Message } from "../../../../../models";
import { useStores } from "../../../../../models";
import useNavigation from "../../../../../hooks/useNavigation";
import { formatPrice } from "../../../../../utils";
import useGlobalTheme from "../../../../../hooks/useGlobalTheme";

const Wrap = styled.div`
  width: 260px;
  max-width: 75vw;
  border-radius: 14px;
  padding: 10px 14px;
  color: #fff;
  cursor: pointer;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Price = styled.div`
  font-size: 28px;
  font-weight: 600;
`;

const Label = styled.div`
  color: rgb(166, 221, 255);
  font-size: 13px;
`;

const TransMessage: React.FC<{ message: Message }> = ({ message }) => {
  const theme = useGlobalTheme();
  const { walletStore, userStore } = useStores();
  const { navigate } = useNavigation();
  const isIn =
    message.receiver?.id === userStore.currentUser?.id ||
    message.receiver_id === userStore.currentUser?.id;

  return (
    <Wrap
      style={{ backgroundColor: theme.colors.primary }}
      onClick={() => {
        walletStore.getWalletInfo();
        navigate("Wallet");
      }}
    >
      <Row>
        <div>
          <Label>喜鹊币</Label>
          <Price>{formatPrice(message.content || 0)}</Price>
          <Label>已转{isIn ? "入" : "出"}</Label>
          {message.attach?.trans_info?.note ? (
            <Label>备注: {message.attach.trans_info.note}</Label>
          ) : null}
        </div>
      </Row>
    </Wrap>
  );
};

export default observer(TransMessage);
